/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export { UserDetails } from "../components/pages/userDetails/user-details";
export { Subscription } from "../components/pages/subscription-page";
